import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Play = createSvgIcon(
  <path d="M2.25.018 21.844 12 2.25 23.982V.018ZM4.5 4.032v15.936L17.531 12 4.5 4.032Z" />,
  'Play'
);

export { Play };